import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export const useStyles = makeStyles((theme) => ({
    continueContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 8,
        paddingBottom: 8,
        marginBottom: 10,
    },
    continue: {
        color: themes.palette.primary.main,
        fontSize: 14,
        width: '100%',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        fontWeight: 600,
        fontFamily: 'PoppinsRegualr',
    },
    quizContainer: {
        width: '100%',
        height: '100%',
        overflowX: 'scroll',
        overflowY: 'hidden',
        flex: 1,
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
    },
    buttonContinue: {
        color: themes.palette.primary.main,
        textDecoration: 'none',
        textTransform: 'uppercase',
        fontFamily: 'PoppinsRegular',
        height: 44,
    },
    hint: {
        fontFamily: 'Smooch',
        fontSize: 24,
    },
    button: {
        width: '100%',
        height: 44,
        padding: 0,
        fontSize: 14,
        fontWeight: 600,
        fontFamily: 'PoppinsRegular',
        background: themes.palette.primary.main,
        borderRadius: '29px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textTransform: 'uppercase',
        border: 'none',
    },
    subTitle: {
        fontSize: '14px',
        fontFamily: 'PoppinsRegular',
        color: '#767676',
        textAlign: 'center',
        whiteSpace: 'pre-line',

        '& b': {
            fontFamily: 'PoppinsMedium',
        },
    },
    titlePage: {
        fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
        fontSize: 24,
        fontWeight: 400,
        textAlign: 'center',
        color: themes.palette.primary.main,
        margin: '12px auto',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    titleContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    titleSkipContainer: {
        width: '50px',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}));
